import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export abstract class StorageService {
  public abstract get(): Storage;
}

// tslint:disable-next-line:max-classes-per-file
@Injectable({
  providedIn: 'root'
})
export class LocalStorageServie extends StorageService {
  public get(): Storage {
    return localStorage;
  }
}
